import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { SupportNumberService } from '../../common/help-menu';
import { getImageSrc } from '../../core/images';
import { HelpCase, HelpCaseId } from './help-center-cases';

@Component({
  selector: 'app-help-case-card',
  templateUrl: './help-case-card.component.html',
  styleUrls: ['./help-case-card.component.scss'],
})
export class HelpCaseCardComponent implements OnInit {
  @Input() helpCase: HelpCase;
  @Input() hasMeetingUrl: string;

  getImageSrc = getImageSrc;
  countryCode = 'US';
  phone$: Observable<string>;

  constructor(private supportNumberService: SupportNumberService) {}

  ngOnInit(): void {
    if (this.helpCase?.id === HelpCaseId.CALL_US) {
      this.phone$ = this.supportNumberService.getSupportNumber();
    }
  }

  showCard(): boolean {
    return (
      this.helpCase.id !== HelpCaseId.BOOK_MEETING ||
      (this.helpCase.id === HelpCaseId.BOOK_MEETING && !!this.hasMeetingUrl)
    );
  }
}
